import {onDOMReady} from './dom';

const asyncModulesLoaders = {
    glightbox: async () => {
        if (!document.querySelector('.fancybox, [data-fancybox]')) {
            return;
        }
        const {init} = await import('./glightbox.js');
        init();
    },
    choices: async () => {
        if (!document.getElementsByClassName('select2input').length && !document.querySelector('select.kvikymart-scdpa__deliveryExternalInput')) {
            return;
        }
        const {init} = await import('./choices.js');
        init();
    },
    claimForm: async () => {
        if (!document.getElementsByClassName('claimForm').length > 0) {
            return;
        }
        const {init} = await import('./claimForm');
        init();
    },
    productAlternativeList: async () => {
        if (!document.getElementsByClassName('productAlternativeList').length) {
            return;
        }
        const {init} = await import('./productAlternativeList.js');
        init();
    },
    userVehicle: async () => {
        if (!document.getElementById('userVehicleButton')) {
            return;
        }
        const {init} = await import('./userVehicle.js');
        init();
    },
    userProfile: async () => {
        if (!document.querySelector('.userProfileNavigation, .userProfileList')) {
            return;
        }
        const {init} = await import('./userProfile.js');
        init();
    },
};

const runAsyncChunks = () => {
    for (const key in asyncModulesLoaders) {
        asyncModulesLoaders[key]();
    }
};

onDOMReady(() => {
    runAsyncChunks();
    document.addEventListener('kvik_event_modal_show_modal', () => {
        asyncModulesLoaders.choices();
    });
    document.addEventListener('KMDeliveryPaymentAddressControl.deliveryPaymentLoaded', () => {
        asyncModulesLoaders.choices();
    });
    document.addEventListener('KMDeliveryPaymentAddressControl.addressFormLoaded', () => {
        asyncModulesLoaders.choices();
    });
    document.addEventListener('KMDeliveryPaymentAddressControl.deliveryMethodChange', () => {
        asyncModulesLoaders.choices();
    });
});
